import { CSVConvertResult, ResultPageDocument } from '../../defs/types';
import { receiptsToCsv } from '../receiptsToCsv';
import { isEmptyReceipt } from './isEmptyReceipt';
import { DocumentDualReceiptEntity } from './types';

export function convertDualReceiptCsv<T extends DocumentDualReceiptEntity>(
  data: ResultPageDocument<T>[]
): CSVConvertResult {
  const receipts = data.flatMap((item) => {
    return item.latest_revision.receipts
      .map((receipt, index) => ({
        summary: {
          ファイル名: item.parsed_path.fullFileName,
          ページ数: item.page?.toString() ?? '-',
          ページ内番号: (index + 1).toString(),
          支払い日付: receipt.payment_date ?? '',
          摘要: receipt.payee?.[0] ?? '',
          事業者番号: receipt.business_number ?? '',
        },
        latest_revision: receipt,
      }))
      .filter((item) => !isEmptyReceipt(item.latest_revision));
  });
  return receiptsToCsv(receipts);
}
